import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, ChevronRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { useSettings, isSet, telHref, mailHref } from "../context/SettingsContext";

export function CTASection({ title = "Un projet de climatisation ou de froid ?", text = "Expliquez-nous votre besoin. Nous étudierons la solution adaptée à votre installation." }) {
  const { settings } = useSettings();
  return (
    <section className="bg-ink text-white relative overflow-hidden">
      <div className="absolute inset-0 tech-grid opacity-40" aria-hidden />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24 relative grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-icelight">HP Froid &amp; Climatisation</span>
          <h2 className="font-heading font-black tracking-tight text-3xl md:text-5xl mt-5 max-w-xl leading-[1.03]">{title}</h2>
          <p className="text-white/60 text-lg mt-5 max-w-lg">{text}</p>
        </Reveal>
        <Reveal delay={0.1} className="lg:justify-self-end w-full lg:max-w-sm">
          <div className="flex flex-col gap-3">
            <Link to="/demande-de-devis" data-testid="cta-devis-btn" className="inline-flex items-center justify-center gap-2 bg-ice text-white rounded-md px-8 py-4 font-bold hover:bg-icehover transition-transform hover:scale-[1.02]">
              Demander un devis <ArrowUpRight size={18} />
            </Link>
            <Link to="/contact" data-testid="cta-contact-btn" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 text-white rounded-md px-8 py-4 font-bold hover:bg-white/20 transition-colors">
              Nous contacter
            </Link>
            <div className="flex flex-col gap-2 mt-4 text-sm">
              {isSet(settings.phone) && (
                <a href={telHref(settings.phone)} className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"><Phone size={16} className="text-icelight" /> {settings.phone}</a>
              )}
              {isSet(settings.email) && (
                <a href={mailHref(settings.email)} className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"><Mail size={16} className="text-icelight" /> {settings.email}</a>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function Breadcrumb({ items }) {
  return (
    <nav className="flex items-center flex-wrap gap-1 text-sm text-muted2" aria-label="fil d'ariane">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1">
          {it.to ? <Link to={it.to} className="hover:text-ice transition-colors">{it.label}</Link> : <span className="text-ink font-semibold">{it.label}</span>}
          {i < items.length - 1 && <ChevronRight size={14} className="text-line mx-1" />}
        </span>
      ))}
    </nav>
  );
}
